import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 19 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.5 14.23q.343 0 .575-.232a.78.78 0 0 0 .233-.575.78.78 0 0 0-.232-.575.78.78 0 0 0-.576-.232.78.78 0 0 0-.575.232.78.78 0 0 0-.233.575q0 .343.232.575a.78.78 0 0 0 .576.233m0-3.653q.32 0 .534-.216a.73.73 0 0 0 .216-.534v-4.5a.73.73 0 0 0-.216-.534.73.73 0 0 0-.534-.216.73.73 0 0 0-.534.216.73.73 0 0 0-.216.534v4.5q0 .319.216.534a.73.73 0 0 0 .534.216M9.502 19q-1.972 0-3.706-.748a9.6 9.6 0 0 1-3.016-2.03 9.6 9.6 0 0 1-2.032-3.016A9.25 9.25 0 0 1 0 9.502Q0 7.53.748 5.796a9.6 9.6 0 0 1 2.03-3.016A9.6 9.6 0 0 1 5.794.748 9.25 9.25 0 0 1 9.498 0q1.972 0 3.706.748a9.6 9.6 0 0 1 3.017 2.03 9.6 9.6 0 0 1 2.03 3.016A9.25 9.25 0 0 1 19 9.498q0 1.972-.748 3.706a9.6 9.6 0 0 1-2.03 3.017 9.6 9.6 0 0 1-3.016 2.03A9.25 9.25 0 0 1 9.502 19"
    }, null, -1)
  ]))]))
}
export default { render: render }